<template>
  <a-modal
    title="Change Detail"
    :visible="modalEdit"
    @ok="handleModalEditOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
  >
    <loading v-if="anggaran.loadingtree" />
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> Cancel </a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleModalEditOk"
      >
        Submit
      </a-button>
    </template>
    <a-form :form="formEditModal">
      <a-form-item label="Description">
        <a-input
          v-decorator="[
            'deskripsi',
            { rules: [{ required: true }], initialValue: data.deskripsi },
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Jenis Anggaran">
        <a-select
          showSearch
          v-decorator="[
            'jns_anggaran_id',
            {
              rules: [{ required: true }],
              initialValue: data.jns_anggaran_id,
            },
          ]"
          @change="handleJenisAnggaran"
        >
          <a-select-option v-for="item in getJenisAnggaran" :key="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Cost Center">
        <a-select
          showSearch
          v-decorator="[
            'cost_center',
            {
              rules: [{ required: true }],
              initialValue: data.cost_center_id,
            },
          ]"
          @change="handle_Cost"
        >
          <a-select-option v-for="item in costCenter" :key="item.value">
            {{ item.text }} ({{
              item.nama_pekerjaan ? item.nama_pekerjaan : "-"
            }})
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Peruntukan">
        <a-select
          :disabled="peruntukan.length == 0"
          showSearch
          v-decorator="[
            'peruntukan',
            {
              rules: [{ required: true }],
              initialValue: data.peruntukan_id,
            },
          ]"
          @change="handle_Peruntukan"
          ref="refperuntukan"
          optionFilterProp="children"
          :filterOption="filterOption"
        >
          <a-select-option v-for="item in peruntukan" :key="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Kode Anggaran">
        <a-tree-select
          v-decorator="[
            'kode_anggaran',
            { rules: [{ required: true }], initialValue: data.anggaran_code },
          ]"
          show-search
          style="width: 100%"
          @select="handlechoiceCost"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="anggaran.tree"
          treeNodeFilterProp="children"
          :filterTreeNode="filterTreeNode"
          placeholder="Please select"
          :treeExpandedKeys="treeExpandedKeys"
          allow-clear
          :disabled="
            anggaran.loadingtree ||
            anggaran.tree == undefined ||
            anggaran.tree.length == 0
          "
          tree-default-expand-all
        >
          <span slot="title" slot-scope="item">
            <table style="width: 100%">
              <tr>
                <td>
                  <span>{{ item.texttitle }} - {{ item.kode_anggaran }}</span>
                </td>
                <td>
                  <span style="float: right">{{
                    formatRupiah(parseFloat(item.rekap))
                  }}</span>
                </td>
              </tr>
            </table>
          </span>
        </a-tree-select>
      </a-form-item>
      <a-form-item label="Petty Cash Expenditures">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right"
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          v-decorator="[
            'pengeluaran_kas_kecil',
            {
              rules: [{ required: true }, { validator: checkPrice }],
              initialValue: data.kredit,
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="Expense Date">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          v-decorator="[
            'tanggal_pengeluaran',
            {
              rules: [{ required: true }],
              initialValue: moment(data.tanggal_pemakaian),
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="End User">
        <a-select
          showSearch
          ref="fendusermodal"
          v-decorator="[
            'end_user',
            {
              rules: [{ required: true }],
              initialValue: data.end_user,
            },
          ]"
          optionFilterProp="children"
          :filterOption="filterOption"
          @change="changeenduser"
        >
          <a-select-option v-for="item in allKaryawan" :key="item.tlc">
            {{ item.nama + " (" + item.tlc + ")" }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Prospect No" v-if="selectedCostCenter=='07'">
        <a-select
          showSearch
          :allowClear="(getTlc_CEO==end_user_klaim ? true : false)"
          :not-found-content="null"
          option-filter-prop="children"
          v-decorator="[
            'prospek',
            {
              rules: [{ required: (getTlc_CEO==end_user_klaim ? false : true) }], initialValue: data.prospek
            },
          ]"
        >
          <a-select-option
            v-for="item in listProspect"
            :key="item.id_prospek"
          >
            {{ item.no_prospek }} - {{ item.description }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Upload Transaction Document">
        <a-upload
          :showUploadList="true"
          :fileList="doctransfiles"
          :beforeUpload="beforedoctransUpload"
          :remove="handledoctransRemove"
          v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
        >
          <a-button>
            <a-icon type="upload" />&nbsp;Select File
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Loading from "@/components/preloader/Loading.vue";

export default {
  props: {
    dataList: {},
    confirmLoading: Boolean,
    modalEdit: Boolean,
    data: {},
    getCostCenter: {},
    getPeruntukan: {},
    getSubPeruntukan: {},
    getAnggaran: {},
    informasi: {},
    debit: Number,
    kredit: Number,
  },
  mixins: [CurrencyFormat],
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getAuth",
      "getActiveProjectkk",
      "getAlokasi",
      "getUsedFor",
      "getJenisAnggaran",
      "getAllKaryawan",
      "getTlc_CEO",
    ]),
    project() {
      return this.getActiveProjectkk.filter((obj) => obj.kategori);
    },
    allKaryawan() {
      let output = this.getAllKaryawan;

      output = _.filter(output, (item) =>
        this.informasi.type == "bod"
          ? item.posisi == "Direktur"
          : item.posisi !== "Direktur"
      );

      return output;
    },
    end_user_klaim(){
      return this.enduser_tlc ? this.enduser_tlc : this.data.end_user
    }
  },
  data() {
    return {
      loading: false,
      kategori: "",
      peruntukan: [],
      subPeruntukan: [],
      costCenter: [],
      anggaran: {
        peruntukan_id: "",
        anggaran_id: "",
        id_pp: "",
        modalvalue: undefined,
        path: "",
        limit: 0,
        tree: [],
        treeModal: [],
        searchValue: "",
        loadingtree: false,
      },
      treeExpandedKeys: [],
      doctransfiles: [],
      selectedCostCenter: null,
      listProspect: [],
      enduser_tlc: null
    };
  },
  created() {
    this.formEditModal = this.$form.createForm(this);
    if (this.getPeruntukan !== undefined) {
      if (this.data.cost_center_id) {
        const peruntukan = this.getPeruntukan.filter(
          (obj) =>
            obj.anggaran_id
              .toLowerCase()
              .indexOf(this.data.cost_center_id.toLowerCase()) >= 0
        );
        this.peruntukan = peruntukan;
      } else {
        this.peruntukan = {};
      }
    }
    if (this.getSubPeruntukan !== undefined) {
      if (this.data.peruntukan_id) {
        const filter = this.getSubPeruntukan.filter(
          (obj) =>
            obj.peruntukan_id
              .toLowerCase()
              .indexOf(this.data.peruntukan_id.toLowerCase()) >= 0
        );
        this.subPeruntukan = filter;
      } else {
        this.subPeruntukan = {};
      }
    }

    let filtera = {};
    if (this.getAnggaran !== undefined) {
      if (this.data.sub_peruntukan_id) {
        filtera = this.getAnggaran.filter(
          (obj) =>
            obj.anggaran_dtl_id
              .toLowerCase()
              .indexOf(this.data.sub_peruntukan_id.toLowerCase()) >= 0
        );
      }
      //this.anggaran = filtera;
    }
    if (this.getCostCenter !== undefined) {
      if (this.data.cost_center_id) {
        filtera = this.getCostCenter.filter(
          (obj) =>
            obj.value
              .toLowerCase()
              .indexOf(this.data.cost_center_id.toLowerCase()) >= 0
        );
      }

      this.costCenter = filtera;
    }
  },
  mounted() {
    //console.log(this.informasi);
    this.getTreeAnggaran(this.data.anggaran_code !== undefined);
    this.doctransfiles = this.data.doctransfiles;
    this.selectedCostCenter = this.data.jns_anggaran_id
    this.anggaran.anggaran_id = this.data.cost_center_id
  },
  methods: {
    moment,
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    // recountAnggaran(arr) {
    //   arr = arr.filter((obj) => obj.path !== "");
    //   if (arr.length > 0) {
    //     //restore nominal ke origin
    //     //console.log("pertama")
    //     arr.forEach((elm) => {
    //       if(elm.path){
    //         let ObjVal = elm.path.split(";");
    //         let path1 = "";
    //         let path2 = "";
    //         let path3 = "";
    //         let trigerpath = true;
    //         let tempTree = this.anggaran.tree;
    //         ObjVal.forEach((element) => {
    //           if (path1 == "") {
    //             path1 += "tempTree[" + element + "]";
    //             path3 = path1;
    //           } else {
    //             path3 = path1 + ".children";
    //             path1 += ".children[" + element + "]";
    //           }
    //           if (trigerpath) {
    //             if (!eval(path3)) {
    //               trigerpath = false;
    //               return;
    //             } else {
    //               if (!eval(path1)) {
    //                 trigerpath = false;
    //                 return;
    //               }
    //             }
    //           }
    //         });

    //         if (trigerpath) {
    //           path2 = eval(path1 + ".origin_rekap");
    //           eval(path1 + ".rekap=" + path2);
    //           //eval(path1+".disabled=false")
    //         }
    //       }
    //     });
    //     //menghitung nominal dengan acuan nominal origin
    //     arr.forEach((elem) => {
    //       if(elem.path){
    //         let ObjVal = elem.path.split(";");
    //         let path = "";
    //         let tpath = "";
    //         let trigerpath = true;
    //         let tempTree = this.anggaran.tree;
    //         ObjVal.forEach((element) => {
    //           if (path == "") {
    //             path += "tempTree[" + element + "]";
    //             tpath = path;
    //           } else {
    //             tpath = path + ".children";
    //             path += ".children[" + element + "]";
    //           }
    //           if (trigerpath) {
    //             if (!eval(tpath)) {
    //               trigerpath = false;
    //               return;
    //             } else {
    //               if (!eval(path)) {
    //                 trigerpath = false;
    //                 return;
    //               }
    //             }
    //           }
    //         });
    //         if (trigerpath) {
    //           let kd_anggrn = eval(path + ".kode_anggaran");
    //           if (kd_anggrn == elem.kode_anggaran) {
    //             let oldVal = eval(path + ".rekap");
    //             let num = oldVal - parseFloat(elem.kredit);
    //             //let exe = path+".rekap="+ num
    //             //eval(exe)
    //             if (num <= 0) {
    //               eval(path + ".disabled=true");
    //             } else {
    //               eval(path + ".disabled=false");
    //             }
    //           }
    //         }
    //         this.anggaran.tree = tempTree;
    //       }
    //     });

    //     if(this.data.path){
    //       let ObjVal = this.data.path.split(";");
    //       let path = "";
    //       let tpath = "";
    //       let trigerpath = true;
    //       let tempTree = this.anggaran.tree;
    //       ObjVal.forEach((element) => {
    //         if (path == "") {
    //           path += "tempTree[" + element + "]";
    //           tpath = path;
    //         } else {
    //           tpath = path + ".children";
    //           path += ".children[" + element + "]";
    //         }
    //         if (trigerpath) {
    //           if (!eval(tpath)) {
    //             trigerpath = false;
    //             return;
    //           } else {
    //             if (!eval(path)) {
    //               trigerpath = false;
    //               return;
    //             }
    //           }
    //         }
    //       });
    //       if (trigerpath) {
    //         let oldVal = eval(path + ".rekap");
    //         let num = oldVal + parseFloat(this.data.kredit);
    //         let exe = path + ".rekap=" + num;
    //         eval(exe);
    //         if (num <= 0) {
    //           eval(path + ".disabled=true");
    //         }
    //       }
    //     }
    //   }
    // },
    async getTreeAnggaran(getloading) {
      //console.log("getTreeAnggaran")
      if (getloading) {
        this.anggaran.loadingtree = true;
      }
      let dataParams = {
        anggaran_id: this.data.cost_center_id,
        tlc: this.getAuth.username,
        peruntukan_id: this.data.peruntukan_id,
        id_kas: this.data.id_kas,
        id_kas_dtl: this.data.id,
      };
      //console.log("modal dataParams",dataParams)
      if (dataParams.peruntukan_id) {
        await axios({
          method: "get",
          url: this.$serviceUrl + "kas_kecil_elektronik/tree_anggaran",
          params: dataParams,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.anggaran.tree = response.data.tree;
            this.anggaran.treeModal = [
              ...this.anggaran.treeModal,
              response.data.tree[0],
            ];

            let dt = this.dataList.filter((item) => item.kredit != "");
            this.treeExpandedKeys = this.getParent(this.anggaran.treeModal);
            //this.recountAnggaran(dt);

            if(this.selectedCostCenter=='07'){
              this.getProspectList();
            }else{
              this.anggaran.loadingtree = false;
            }
          })
          .catch((err) => {
            this.anggaran.loadingtree = false;
            //let responses = Object.assign({}, err.response);
            //console.log("error",responses,err)
            this.displayMessageValue("error", err);
          });
      }
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(value, record) {
      this.data.limit = record.dataRef.rekap;
      this.data.path = record.dataRef.path;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handle_Cost(e) {
      //console.log("jos")
      this.$nextTick(function () {
        //this.formEditModal.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
        this.formEditModal.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.subPeruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;
      this.anggaran.anggaran_id = e;
      this.data.cost_center_id = e;
    },
    handle_Peruntukan(e) {
      //console.log("handleEdit",e)
      this.$nextTick(function () {
        //this.formEditModal.resetFields(["sub_peruntukan", "kode_anggaran"]);
        this.formEditModal.setFieldsValue({
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      this.anggaran.peruntukan_id = e;
      this.data.peruntukan_id = e;
      const filter = this.getSubPeruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.subPeruntukan = filter;
      this.getTreeAnggaran(true);
      let arr = this.dataList.filter((item) => item.kredit !== "");
      //this.recountAnggaran(arr);
    },
    handle_SubPeruntukan(e) {
      this.$nextTick(function () {
        //this.formEditModal.resetFields(["kode_anggaran"]);
        this.formEditModal.setFieldsValue({
          kode_anggaran: null,
        });
      });
      const filter = this.getAnggaran.filter(
        (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      //this.anggaran = filter;
    },
    handleCancel(e) {
      Event.$emit("modalCancel", false);
      this.formEditModal.resetFields();
      //console.log(this.$refs)
      Event.$emit("resetdtlpemakaian", true);
    },
    handleModalEditOk() {
      this.formEditModal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(moment(values.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }

        let res = ((this.debit>0?this.debit:(Number(values.pengeluaran_kas_kecil)+this.kredit))-(this.kredit?this.kredit:0)+Number(values.pengeluaran_kas_kecil)) > 0 ? false : true
        if(res){
          this.displayMessageValue("error-other", "Calculate Grand total can't be minus!");
          return;
        }

        if (parseFloat(this.data.limit) < values.pengeluaran_kas_kecil) {
          this.displayMessageValue(
            "limit-anggaran",
            this.formatRupiah(this.data.limit)
          );
          return;
        } else {
          this.loading = true;
          let url =
            this.data.type === "revised"
              ? "kas_kecil_elektronik/revisi_detil_pemakaian_edit"
              : "kas_kecil_elektronik/detil_pemakaian_edit";
          let kd = values.kode_anggaran.split(";");

          let addData = new FormData();
          addData.append("tlc", this.getAuth.username);
          addData.append("id", this.data.id);
          addData.append("id_kas", this.data.id_kas);
          addData.append("tanggal_pengeluaran", values.tanggal_pengeluaran.format("YYYY-MM-DD"));
          addData.append("deskripsi", values.deskripsi);
          addData.append("project", values.proyek);
          addData.append("allocation", values.alokasi);
          addData.append("pengeluaran_kas_kecil", values.pengeluaran_kas_kecil);
          addData.append("cost_center", values.cost_center);
          addData.append("peruntukan", values.peruntukan);
          addData.append("sub_peruntukan", kd[kd.length - 2]);
          addData.append("kode_anggaran", kd[kd.length - 1]);
          addData.append("anggaran_dtl_val_id", kd[kd.length - 1]);
          addData.append("jns_anggaran_id", values.jns_anggaran_id);
          addData.append("path", this.data.path);
          addData.append("end_user", values.end_user);
          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }
          if (values.prospek) {
            addData.append("prospek", values.prospek);
          }

          axios({
            method: "post",
            url: this.$serviceUrl + url,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              // "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.loading = false;
              this.formEditModal.resetFields();
              Event.$emit("modalCancel", false);
              Event.$emit("fetchPemakaian", true);
              Event.$emit("resetdtlpemakaian", true);
            })
            .catch((err) => {
              this.loading = false;
              Event.$emit("resetdtlpemakaian", true);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              console.log("error : " + err);
            });
        }
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    handleProyek(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.kategori = filter[0].kategori;
      this.formEditModal.setFieldsValue({
        alokasi: "",
      });
    },
    handleJenisAnggaran(e) {
      this.selectedCostCenter = e
      this.data.prospek = null
      this.listProspect = []
      this.formEditModal.setFieldsValue({
        cost_center: null,
        peruntukan: null,
        sub_peruntukan: null,
        kode_anggaran: null,
        prospek: null
      });
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.costCenter = filter;
      this.peruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      this.subPeruntukan = [];
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
    async getProspectList(){
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: this.anggaran.anggaran_id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = response.data.data ? response.data.data : [];
        this.anggaran.loadingtree = false;
      })
      .catch(() => {
      });
    },
    changeenduser(val){
      this.enduser_tlc = val
    }
  },
};
</script>

<style></style>
